import React from 'react';
import clsx from 'clsx';

export default function QuantityButton({ onClick, className, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        className,
        'cp_quantity-button transition py-0.5 px-1 text-gray-600 hover:text-gray-800 focus:outline-none focus:ring-none',
      )}
    >
      {children}
    </button>
  );
}
